module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI0IDUuMjVMMjQuMzc1IDBMMjQuNzUgNS4yNUwzMCA1LjYyNUwyNC43NSA2TDI0LjM3NSAxMS4yNUwyNCA2TDE4Ljc1IDUuNjI1TDI0IDUuMjVaTTEwLjUgMTQuMjVMMTEuMjUgMy43NUwxMiAxNC4yNUwyMi41IDE1TDEyIDE1Ljc1TDExLjI1IDI2LjI1TDEwLjUgMTUuNzVMMCAxNUwxMC41IDE0LjI1Wk0yNC4zNzUgMTguNzVMMjQuNzUgMjRMMzAgMjQuMzc1TDI0Ljc1IDI0Ljc1TDI0LjM3NSAzMEwyNCAyNC43NUwxOC43NSAyNC4zNzVMMjQgMjRMMjQuMzc1IDE4Ljc1WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sparkles-sharp-solid.svg
// module id = FBuA
// module chunks = 134